import React from 'react';
import WebhookLine from "./components/WebhookLine";
import {LinkIcon} from "@heroicons/react/24/outline";

function WebhookList({ webhooks }) {
    if (!webhooks?.length) return (
        <div className="bg-white rounded-[2rem] shadow-sm border border-gray-100 overflow-hidden">
            <div className="px-8 py-6 border-b border-gray-50 flex items-center gap-3">
                <div className="p-2.5 rounded-2xl bg-[#0b6a8c]/10">
                    <LinkIcon className="h-6 w-6 text-[#0b6a8c]" />
                </div>
                <h3 className="text-lg font-bold text-gray-900">Webhook Deliveries</h3>
            </div>
            <div className="p-10 text-center">
                <p className="text-gray-400 font-medium">No webhooks found</p>
                <div className="mt-4 px-4 py-2 bg-amber-50 border border-amber-100 rounded-xl inline-block shadow-inner">
                    <p className="text-xs text-amber-800">Webhook calls before 26-09-2025 are archived. If required, please contact the system administrator.</p>
                </div>
            </div>
        </div>
    );

    const webhookLines = webhooks?.map((w) => (
        <WebhookLine key={w?.id} webhook={w} />
    ));

    return (
        <div className="bg-white rounded-[2rem] shadow-sm border border-gray-100 overflow-hidden">
            <div className="px-8 py-6 border-b border-gray-50 flex items-center justify-between">
                <div className="flex items-center gap-3">
                    <div className="p-2.5 rounded-2xl bg-[#0b6a8c]/10">
                        <LinkIcon className="h-6 w-6 text-[#0b6a8c]" />
                    </div>
                    <h3 className="text-lg font-bold text-gray-900">Webhook Deliveries</h3>
                </div>
                <span className="bg-cyan-50 text-[#0b5f82] text-[10px] font-black uppercase tracking-wider px-3 py-1 rounded-full">
                    {webhooks?.length}
                </span>
            </div>
            <div className="px-8 py-4 bg-amber-50 border-b border-amber-100">
                <p className="text-xs text-amber-800">Webhook calls before 26-09-2025 are archived. If required, please contact the system administrator.</p>
            </div>
            <div className="overflow-x-auto">
                <div className="inline-block min-w-full align-middle p-4 sm:p-6">
                    <div className="min-w-[800px]">
                        <table className="min-w-full divide-y divide-gray-100">
                            <thead className="bg-gray-50/50">
                            <tr>
                                <th className="px-4 py-3.5 first:pl-8 ltr:text-left rtl:text-right text-[10px] font-black uppercase tracking-widest text-gray-400">Event</th>
                                <th className="px-4 py-3.5 ltr:text-left rtl:text-right text-[10px] font-black uppercase tracking-widest text-gray-400">Endpoint</th>
                                <th className="px-4 py-3.5 ltr:text-left rtl:text-right text-[10px] font-black uppercase tracking-widest text-gray-400">Status</th>
                                <th className="px-4 py-3.5 ltr:text-left rtl:text-right text-[10px] font-black uppercase tracking-widest text-gray-400">Response Code</th>
                                <th className="px-4 py-3.5 ltr:text-left rtl:text-right text-[10px] font-black uppercase tracking-widest text-gray-400">Executed At</th>
                            </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-50">
                            {webhookLines}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default WebhookList;
